module.exports = __webpack_public_path__ + "img/01.e3b3446c.png";